// extracted by mini-css-extract-plugin
export var video = "Vimeo-module--video--15Ia7";